import src from "IMAGE";
export default { src, width: 900, height: 168, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/ANHR0l7Nzc1mzc3NZcjJyWvNzs5lzMzMberq6in///8AeWQWtDh9bNgAAAAASUVORK5CYII="};
